export default __webpack_public_path__ + "static/media/switch_of.8f7b45e1.png";